import { CompanyEntity as BaseCompanyEntity } from "./CompanyEntity";
import {
  CompanyBoard,
  CompanySearch,
  CompanyRadar,
} from "./CompanyEntity.presets";
import { CompanyEntitySkeleton } from "./CompanyEntity.Skeleton";

type CompanyEntityWithStatics = typeof BaseCompanyEntity & {
  Board: typeof CompanyBoard;
  Search: typeof CompanySearch;
  Radar: typeof CompanyRadar;
  Skeleton: typeof CompanyEntitySkeleton;
};

const CompanyEntity = BaseCompanyEntity as CompanyEntityWithStatics;
CompanyEntity.Board = CompanyBoard;
CompanyEntity.Search = CompanySearch;
CompanyEntity.Radar = CompanyRadar;
CompanyEntity.Skeleton = CompanyEntitySkeleton;

export {
  CompanyEntity,
  CompanyBoard,
  CompanySearch,
  CompanyRadar,
  CompanyEntitySkeleton,
};
export { toCompanyEntityData } from "./CompanyEntity.types";
export type {
  CompanyEntityProps,
  CompanyEntityData,
  CompanyEntityActions,
  CompanyEntityLayout,
  CompanyEntityDensity,
} from "./CompanyEntity.types";
